import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import {
    ProfileParamsBuilder,
    AddressParamsBuilder,
    ShippingAddressParamsBuilder
} from '@/core/Account/model/AccountModel.js';

/**
 * @method getProfile
 * @method getPoint
 * @method updateProfile
 * @method updateShippingAddress
 * @method registerUser
 * @method changePassword
 */
export default {
    config: function () {
        return Vue.bzbsConfig;
    },

    /**
     * Get user profile.
     * @param {object} strBzbsToken
     * @return {promises} Profile response.
     */
    getProfile: function (strBzbsToken) {
        var strUrl = this.config().bzbsUrl + "/profile/me";
        return BzbsApi.connectBzbsGet(strUrl, strBzbsToken);
    },

    getProfileAia: function (jwt) {
        var strUrl = this.config().bzbsUrl + "/profile";
        return BzbsApi.connectBzbsGet(strUrl, jwt);
    },

    /**
     * Get point.
     * @param {string} strBzbsToken
     * @return {promises} Point response.
     */
    getPoint: function (strBzbsToken) {
        var strUrl = this.config().bzbsUrl + "/profile/me/updated_points";
        return BzbsApi.connectBzbsGet(strUrl, strBzbsToken);
    },

    /**
     * Update user profile.
     * @param {string} strBzbsToken
     * @param {object} objProfileInfo
     * @param {object} objProfileAdress
     * @param {string} strExtendJson
     * @param {string} strUploadKey
     * @param {object} objUpload
     * @return {promises} user response.
     */
    updateProfile: function (strBzbsToken, profile, profileAddress, strExtendJson, strUploadKey, objUpload) {
        var profileParams = new ProfileParamsBuilder();
        var params = profileParams.getParams(profile);
        if (profileAddress) {
            var addressParams = new AddressParamsBuilder();
            var addr = addressParams.getParams(profileAddress)
            params = {...params, ...addr};
        }

        if (strExtendJson)
            params.extendjsonstring = strExtendJson;

        var strUrl = this.config().bzbsUrl + "/profile/me";
        return BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params, strUploadKey, objUpload);
    },

    /**
     * Update user shipping address.
     * @param {string} strBzbsToken
     * @param {object} objProfileShippingAddress
     * @return {promises} Profile shipping address.
     */
    updateShippingAddress: function (strBzbsToken, objProfileShippingAddress) {
        var paramsShipping = new ShippingAddressParamsBuilder();
        var params = paramsShipping.getParams(objProfileShippingAddress);
        var strUrl = this.config().bzbsUrl + "/profile/me/shipping";
        return BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params);
    },

    registerUser: function (objRegisterModel, haveOTP, objRegisterOTPModel, objRegisterDeviceInfoModel, objRegisterAddressModel, objRegisterOtherInfoModel) {
        var params = {
            app_id: Vue.bzbsConfig.client_id,
        };

        if (!objRegisterModel) {
            return null;
        }

        if (haveOTP && !objRegisterOTPModel) {
            return null;
        }

        //Basic info.
        if (objRegisterModel.strUsername)
            params.username = objRegisterModel.strUsername;

        if (objRegisterModel.strPassword)
            params.password = objRegisterModel.strPassword;

        if (objRegisterModel.strConfirmPassword)
            params.confirmpassword = objRegisterModel.strConfirmPassword;

        if (objRegisterModel.strFirstname)
            params.firstname = objRegisterModel.strFirstname;

        if (objRegisterModel.strLastname)
            params.lastname = objRegisterModel.strLastname;

        if (objRegisterModel.strEmail)
            params.email = objRegisterModel.strEmail;

        if (objRegisterModel.strContactNumber)
            params.contact_number = objRegisterModel.strContactNumber;

        if (objRegisterModel.strBirthDate)
            params.birthdate = objRegisterModel.strBirthDate;

        if (objRegisterModel.strNationalID)
            params.idcard = objRegisterModel.strNationalID;

        if (objRegisterModel.strGender)
            params.gender = objRegisterModel.strGender;

        //OTP.
        if (objRegisterOTPModel) {
            if (objRegisterOTPModel.strOTP)
                params.otp = objRegisterOTPModel.strOTP;

            if (objRegisterOTPModel.strRefCode)
                params.refcode = objRegisterOTPModel.strRefCode;
        }

        //Device info.
        if (objRegisterDeviceInfoModel) {
            if (objRegisterDeviceInfoModel.strCarrier)
                params.carrier = objRegisterDeviceInfoModel.strCarrier;

            if (objRegisterDeviceInfoModel.strClientVersion)
                params.client_version = objRegisterDeviceInfoModel.strClientVersion;

            if (objRegisterDeviceInfoModel.strOperationSystem)
                params.os = objRegisterDeviceInfoModel.strOperationSystem;

            if (objRegisterDeviceInfoModel.strPlatform)
                params.platform = objRegisterDeviceInfoModel.strPlatform;

            if (objRegisterDeviceInfoModel.strMacAddress)
                params.mac_address = objRegisterDeviceInfoModel.strMacAddress;
        }

        if (objRegisterAddressModel) {
            if (objRegisterAddressModel.strAddress)
                params.address = objRegisterAddressModel.strAddress;

            if (objRegisterAddressModel.strZipcode)
                params.zipcode = objRegisterAddressModel.strZipcode;

            if (objRegisterAddressModel.strProvinceCode)
                params.province_code = objRegisterAddressModel.strProvinceCode;

            if (objRegisterAddressModel.strProvinceName)
                params.province_name = objRegisterAddressModel.strProvinceName;

            if (objRegisterAddressModel.strDistrictCode)
                params.district_code = objRegisterAddressModel.strDistrictCode;

            if (objRegisterAddressModel.strDistrictName)
                params.district_name = objRegisterAddressModel.strDistrictName;

            if (objRegisterAddressModel.strSubDistrictCode)
                params.subdistrict_code = objRegisterAddressModel.strSubDistrictCode;

            if (objRegisterAddressModel.strSubDistrictName)
                params.subdistrict_name = objRegisterAddressModel.strSubDistrictName;

            if (objRegisterAddressModel.strLatitude)
                params.latitude = objRegisterAddressModel.strLatitude;

            if (objRegisterAddressModel.strLongitude)
                params.longitude = objRegisterAddressModel.strLongitude;
        }

        if (objRegisterOtherInfoModel) {
            if (objRegisterOtherInfoModel.strInfo)
                params.info = objRegisterOtherInfoModel.strInfo;

            if (objRegisterOtherInfoModel.strCustomInfo)
                params.custom_info = objRegisterOtherInfoModel.strCustomInfo;
        }

        var strUrl = this.config().bzbsUrl + "/auth/register";
        return BzbsApi.connectBzbsPost(strUrl, null, params, null, null);
    },

    /**
     * Change bzbs password
     * @param {string} strBzbsToken
     * @param {string} strCurrent Current password
     * @param {string} strChange New password
     */
    changePassword: function (strBzbsToken, strCurrent, strChange) {
        var params = {
            current: strCurrent,
            change: strChange,
        };

        var strUrl = this.config().bzbsUrl + "/profile/me/change_password";
        return BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params, null, null);
    }
}

